<template>
  <div>
    <!------------- start toast / snackbar -------------------------->
    <success-toast-component :SuccessToast="SuccessToast" @close="close" />
    <error-toast-component :ErrorToast="ErrorToast" @close="close" />
    <!------------- end toast / snackbar -------------------------->
    <div>
      <!------------------Testimonial Section start------------------------>
      <v-row class="d-flex justify-space-between" flat>
        <v-col>
          <h1 class="heading-1">Testimonials</h1>
        </v-col>
      </v-row>
      <!------------------Search and filter------------------------>
      <v-row class="mt-6">
        <v-col cols="12" md="4" sm="6">
          <v-card flat style="color: #f2f3f9">
            <v-text-field
              dense
              outlined
              prepend-inner-icon="mdi-magnify"
              label="Search"
              v-model="search"
              @input="searchData()"
              single-line
            >
            </v-text-field>
          </v-card>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <v-card
            height="45"
            outlined
            class="px-2 mt-n1 d-flex justify-start align-center"
            style="cursor: pointer"
            @click="filterDialog = true"
          >
            <div
              class="d-flex justify-space-between align-center"
              style="width: 100%"
            >
              <div>
                <v-icon>mdi-tune</v-icon>
                <span class="text_style mx-1" style="letter-spacing: 1px"
                  >Filters</span
                >
              </div>

              <div>
                <v-icon>mdi-menu-down</v-icon>
              </div>
            </div>
          </v-card>
          <!------------------------fliter diloag------------------------------------------>
          <v-dialog v-model="filterDialog" max-width="430" persistent>
            <v-card class="py-5">
              <v-card-title
                class="mb-5 d-flex justify-space-between align-center"
              >
                <div class="text-h5"><b> Filters</b></div>
                <div>
                  <v-btn text depressed class="pa-0" @click="cleanFilter()">
                    <span
                      class="text_style primary--text"
                      style="letter-spacing: 0px"
                      >Clean filters</span
                    >
                  </v-btn>
                  <v-icon class="ml-3" @click="filterDialog = false"
                    >mdi-close</v-icon
                  >
                </div>
              </v-card-title>

              <v-card-text>
                <v-select
                  outlined
                  v-model="filterObj.Visibility"
                  :items="['Yes', 'No']"
                  dense
                  hide-details
                  label="By Visibility"
                  persistent-hint
                  :menu-props="{ maxHeight: '400' }"
                ></v-select>
                <v-autocomplete
                  clearable
                  outlined
                  class="my-5"
                  :items="GetTestimonialsByFilter"
                  item-text="submittedBy"
                  item-value="Id"
                  v-model="filterObj.SubmittedById"
                  dense
                  :menu-props="{ maxHeight: '400' }"
                  hide-details
                  label="By Submitted"
                  multiple
                  persistent-hint
                ></v-autocomplete>
                <v-menu
                  ref="datarangemenu"
                  v-model="datarangemenu"
                  :close-on-content-click="false"
                  :return-value.sync="Renewaldates"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      clearable
                      v-model="filterObj.formatDate"
                      label="Submission Date"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      dense
                      outlined
                      hide-details
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="Renewaldates"
                    no-title
                    scrollable
                    range
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="datarangemenu = false">
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.datarangemenu.save(Renewaldates)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>

                <v-select
                  outlined
                  class="my-5"
                  v-model="filterObj.Modality"
                  :items="filterModalityList"
                  dense
                  :menu-props="{ maxHeight: '400' }"
                  hide-details
                  label="Modality"
                  multiple
                  persistent-hint
                ></v-select>
                <v-select
                  outlined
                  class="my-5"
                  v-model="filterObj.Languages"
                  :items="filterLangaugeList"
                  :menu-props="{ maxHeight: '400' }"
                  dense
                  hide-details
                  label="Languages"
                  multiple
                  persistent-hint
                ></v-select>
                <v-select
                  outlined
                  class="my-5"
                  v-model="filterObj.pinned"
                  :items="filterpinnedList"
                  :menu-props="{ maxHeight: '400' }"
                  dense
                  hide-details
                  label="Pinned"
                  persistent-hint
                ></v-select>
                <!---------------------Type-modalitiy model filter-------------------------------->
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="#646464"
                  outlined
                  depressed
                  class="px-5"
                  text
                  @click="filterDialog = false"
                >
                  <span class="text_style"> Cancel </span>
                </v-btn>
                <v-btn
                  color="primary"
                  class="px-8 ml-2"
                  @click="sendFilters()"
                  depressed
                >
                  <span class="text_style"> Save Filters </span>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
      <!------------------End Search and Filter------------------------>

      <!------------------Testimonial Datatables------------------------>
      <!-- {{ GetTestimonials.Data }} -->
      <v-card class="mt-2" outlined>
        <v-data-table
          :headers="headers"
          :loading="tableLoader"
          loading-text="Loading... Please wait"
          :search="search"
          :items="GetTestimonials.Data"
          :page.sync="page"
          :items-per-page="displayedItemsPerPage"
          @page-count="pageCount = $event"
          hide-default-footer
        >
          <template v-slot:[`item.Testimonials`]="{ item }">
            <div style="display: flex; align-items: center" class="pa-2">
              <span class="box" v-html="item.Testimonials"></span>
            </div>
          </template>
          <template v-slot:[`item.index`]="{ index }">
            <div class="index_test_h1">
              {{ index + displayedItemsPerPage * (page - 1) + 1 }}
            </div>
          </template>

          <template v-slot:[`item.CreatedBy`]="{ item }">
            <span v-if="item.CreatedBy.length > 0" class="index_test_h2">
              {{ item.CreatedBy[0].Name }}
            </span>
          </template>
          <template v-slot:[`item.CreatedDate`]="{ item }">
            <span class="index_test_h2">
              {{ formatDate(item.CreatedDate) }}
            </span>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <v-btn icon @click="toggleIsPin(item.Id)">
              <v-icon v-if="!item.Pinned" color="orange"
                >mdi-pin-outline</v-icon
              >
              <v-icon v-else color="orange">mdi-pin</v-icon>
            </v-btn>
            <v-btn icon @click="toggleIsPlaying(item.Id)">
              <v-icon v-if="item.Visibility" color="primary">mdi-eye</v-icon>
              <v-icon v-else>mdi-eye-off</v-icon>
            </v-btn>

            <!------------------Testimonial datatabel List------------------------>
            <v-menu
              transition="scroll-y-transition"
              offset-y
              color="transparent"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="#A1A1A6" v-bind="attrs" v-on="on">
                  mdi-dots-horizontal
                </v-icon>
              </template>
              <v-card flat>
                <v-list class="px-3 pt-5" color="transparent ">
                  <!------------------ View Testimonial Dialog----------------------->
                  <v-btn
                    depressed
                    color="transparent"
                    block
                    @click="toggleIsPin(item.Id)"
                  >
                    <v-icon>mdi-pin-outline </v-icon>
                    <span class="px-4 text_style" :dialog="dialog"
                      >Pin / Unpin</span
                    >
                  </v-btn>
                  <!------------------End Dialog------------------------>
                </v-list>
                <v-list
                  class="px-3 pt-1 index_h7_text_style"
                  color="transparent"
                  v-if="Permission.Edit"
                >
                  <!------------------ Preview Testimonial Dialog------------------------>
                  <v-btn
                    depressed
                    color="transparent"
                    block
                    class="d-flex justify-start"
                    @click="previewDialouge(item)"
                  >
                    <v-icon color="#646464">mdi-open-in-new</v-icon>
                    <span class="ml-4 text_style">Preview</span>
                  </v-btn>
                  <!------------------ End Preview Testimonial  Dialog------------------------>
                </v-list>
                <v-list
                  class="px-3 pt-1 index_h7_text_style"
                  color="transparent"
                  v-if="Permission.Edit"
                >
                  <!------------------Testimonial Edit Dialog------------------------>
                  <v-btn
                    depressed
                    color="transparent"
                    block
                    class="d-flex justify-start"
                    @click="editDialouge(item)"
                  >
                    <v-icon color="#646464">mdi-pencil</v-icon>
                    <span class="ml-4 text_style">Edit</span>
                  </v-btn>
                  <!------------------ End Testimonial Edit Dialog------------------------>
                </v-list>
                <!------------------Testimonial List Delete ------------------------>
                <v-list
                  class="px-3 pt-1"
                  color="transparent"
                  v-if="Permission.Delete"
                >
                  <!------------------Testimonial Delete Dialog start------------------------>
                  <v-btn
                    depressed
                    color="transparent"
                    block
                    class="d-flex justify-start"
                    @click="openDelDialouge(item.Id)"
                  >
                    <v-icon color="#646464">mdi-delete</v-icon>
                    <span class="ml-4 text_style">Delete</span>
                  </v-btn>
                  <!------------------End Testimonial delete Dialog------------------------>
                </v-list>
                <!------------------End List------------------------>
              </v-card>
            </v-menu>
          </template>
        </v-data-table>
      </v-card>
      <v-card flat class="my-9 d-flex justify-end align-center">
        <span class="text_transform pa-0 ma-0">Per page : </span>
        <v-card flat width="100" class="mx-5">
          <v-select
            :items="ItemsPerPageItems"
            label="Items per page"
            v-model="itemsPerPage"
            @change="handleItemPerPage()"
          ></v-select>
        </v-card>
        <v-pagination
          v-model="page"
          :length="pageCount"
          :total-visible="5"
          @change="fetchData()"
        ></v-pagination
      ></v-card>
      <!------------------Testimonial End------------------------>
    </div>
    <!------------Preview Testimonial---------------------------->
    <v-dialog v-model="infodialog" @click:outside="closeDialog" max-width="400">
      <v-card>
        <div class="mx-4 py-1 d-flex justify-space-between">
          <!-- <v-icon @click="infodialog = false">
                          mdi-dots-horizontal</v-icon
                        > -->
        </div>
        <div>
          <preview-testimonials :selectedTestimonial="selectedTestimonial" />
        </div>
        <div class="d-flex justify-end mx-3 py-2" flat></div>
      </v-card>
    </v-dialog>
    <!------------Edit Testimonial---------------------------->
    <v-dialog v-model="edittestimonaildialog" persistent max-width="822">
      <v-card class="px-6">
        <div class="px-5 py-5">
          <div class="d-flex justify-space-between">
            <h4 class="heading-5 mt-5">Edit Testimonial</h4>
            <v-icon @click="edittestimonaildialog = false">mdi-close</v-icon>
          </div>
          <div>
            <edit-testimonail :selectedTestimonial="selectedTestimonial" />
          </div>
          <div class="d-flex justify-end mx-3 py-5">
            <v-btn
              class="px-6 py-6 index_h7_text_style"
              color="#A1A3A8"
              text
              @click="edittestimonaildialog = false"
            >
              <span class="text_style"> Cancel </span>
            </v-btn>

            <v-btn
              depressed
              color="primary"
              class="px-6 py-6 index_h_text_style"
              :disabled="btnloader"
              @click="send()"
            >
              <span class="text_style" v-if="btnloader != true">
                Save changes
              </span>
              <v-progress-circular
                v-else
                indeterminate
                size="20"
                class="px-5"
                color="white"
                v-show="btnloader"
              ></v-progress-circular>
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <!------------Delete Testimonial---------------------------->
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5"> Warning </v-card-title>
        <v-card-text class="index_span_2_style"
          >Are you sure you want to delete?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog = false">
            Cancel
          </v-btn>
          <v-btn color="primary" :disabled="btnloader" @click="DdialogClose()">
            <span v-if="btnloader != true">Confirm</span>
            <v-progress-circular
              indeterminate
              v-else
              size="20"
              class="px-5"
              color="white"
              v-show="btnloader"
            ></v-progress-circular>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import EditTestimonail from "../../components/Testimonials/EditTestimonail.vue";
import PreviewTestimonials from "../../components/Testimonials/PreviewTestimonials.vue";
import ErrorToastComponent from "../../components/Toast/ErrorToast.component.vue";
import SuccessToastComponent from "../../components/Toast/SuccessToast.component.vue";
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  components: {
    PreviewTestimonials,
    EditTestimonail,
    SuccessToastComponent,
    ErrorToastComponent,
  },
  data() {
    return {
      filterObj: {
        formatDate: "",
      },
      datarangemenu: false,
      dates: ["2019-09-10", "2019-09-20"],
      filterLangauge: [],

      Renewaldates: [],
      filterLangaugeList: [
        "English",
        "French",
        "German",
        "Japanese",
        "Italian",
        "Portuguese",
        "Filipino",
        "Spanish",
        "Chinese",
        "Russian",
      ],
      filterModality: [],
      filterModalityList: [
        "Access",
        "BodyTalk",
        "BodyTalk for Animals",
        "BreakThrough",
        "MindScape",
        "FreeFall",
        "PaRama",
      ],
      filtersArray: [],
      filterDate: [],
      filterTypeModality: [],
      filterTypeModalityList: ["Visible", "Invisible"],
      filterpinned: [],
      filterpinnedList: ["Yes", "No"],
      filterDialog: false,
      ItemsPerPageItems: [10, 50, 100, 200],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      Permission: {},
      infodialog: false,
      SuccessToast: false,
      ErrorToast: false,
      dialog: false,
      editdialog: false,
      edittestimonaildialog: false,
      tableLoader: false,
      isPlaying: false,
      btnloader: false,
      search: "",
      filter: "",
      filterItem: [
        "By Visibile",
        "By Invisibile",
        "By Date",
        "By Modality",
        "Type(User,Practitoner,Instructer,Student)",
        "By User",
        "New Testimonials",
      ],
      selectedTestimonial: "",
      headers: [
        { text: "#", value: "index", sortable: false },
        { text: "", value: "images", sortable: false },
        { text: "Message", value: "Testimonials", sortable: false },
        { text: "Submited By", value: "CreatedBy", sortable: false },
        { text: "Date Added", value: "CreatedDate", sortable: false },
        { text: "Modality", value: "Modalities", sortable: false },
        { text: "Language ", value: "Languages", sortable: false },
        { text: "", value: "actions", sortable: false },
      ],
      DataTableOne: [],
      Fitems: [],
    };
  },
  watch: {
    page() {
      this.fetchData();
    },
    dateRangeText() {
      this.filterObj.formatDate = this.dateRangeText;
    },
  },
  computed: {
    ...mapGetters(["GetUserRolePermissions", "GetTestimonials", "GetWebUser","GetTestimonialsByFilter"]),

    dateRangeText() {
      let firstDate = this.Renewaldates[0];
      let lastDate = this.Renewaldates[1];
      let formatDate =
        moment(firstDate).format("YYYY-MM-DD") +
        " to " +
        moment(lastDate).format("YYYY-MM-DD");
      return formatDate;
    },
    displayedItemsPerPage() {
      return this.itemsPerPage === "All"
        ? this.GetTestimonials.Data.length
        : this.itemsPerPage;
    },
  },

  mounted() {
    this.Permission = this.GetUserRolePermissions.RolePermissions.find(
      (x) => x.Module === "Testimonials"
    );
    // this.$store.dispatch("GetWebUser");
    this.fetchData();
  },
  methods: {
    handleItemPerPage() {
      if (this.page !== 1) {
        this.page = 1;
      }
      this.fetchData();
    },
    sendFilters() {
      this.page = 1;
      this.filtersArray = [];
      if (this.filterObj.Visibility && this.filterObj.Visibility.length > 0) {
        this.filtersArray.push({
          Key: "Visibility",
          Value: this.filterObj.Visibility,
        });
      }
      if (
        this.filterObj.SubmittedById &&
        this.filterObj.SubmittedById.length > 0
      ) {
        this.filtersArray.push({
          Key: "SubmittedBy",
          Value: this.filterObj.SubmittedById.join(","),
        });
      }

      if (this.filterObj.pinned) {
        this.filtersArray.push({
          Key: "Pinned",
          Value: this.filterObj.pinned,
        });
      }
      if (this.filterObj.formatDate) {
        this.filtersArray.push({
          Key: "DateAdded",
          Value: this.filterObj.formatDate,
        });
      }
      if (this.filterObj.Modality) {
        this.filtersArray.push({
          Key: "Modality",
          Value: this.filterObj.Modality.toString(),
        });
      }
      if (this.filterObj.Languages) {
        this.filtersArray.push({
          Key: "Languages",
          Value: this.filterObj.Languages.toString(),
        });
      }

      this.fetchData();
      this.filterDialog = false;
    },
    searchData(){
      this.page = 1;
      this.fetchData();
    },
    async fetchData() {
      this.tableLoader = true;
      this.filtersArray.push({
        Key: "Type",
        Value: "Admin",
      });
      var obj = {
        page: this.search ? 1 : this.page,
        pageSize: this.itemsPerPage === "All" ? "All" : this.itemsPerPage,
        search: this.search,
        filters: JSON.stringify(this.filtersArray) ?? [],
      };
      await this.$store.dispatch("GetTestimonials", obj).then((res) => {
        console.log("res", res);
        if (this.itemsPerPage != "All") {
          this.pageCount = Math.ceil(res.TotalRecords / this.itemsPerPage);
        } else {
          this.pageCount = 1;
        }
      });
      this.tableLoader = false;
      this.GetTestimonialsByFilter.length == 0 && this.$store.dispatch("GetTestimonialsByFilter")
    },
    formatDate(date) {
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      date = new Date(date);
      const month = months[date.getMonth()];
      const day = date.getDate();
      const year = date.getFullYear();

      return `${month} ${day}, ${year}`;
    },
    async toggleIsPin(obj) {
      await this.$store.dispatch("ToggleTestimonialPinned", obj);
      this.fetchData();
    },
    async toggleIsPlaying(obj) {
      await this.$store.dispatch("ToggleTestimonialVisibility", obj);
      this.fetchData();
    },
    async deleteTestimonial() {
      await this.$store.dispatch("DeleteTestimonial", this.selectedTestimonial);
      this.fetchData();
    },
    async send() {
      this.btnloader=true;
      await this.$store
        .dispatch("UpdateTestimonial", this.selectedTestimonial)
        .then((res) => {
          if (res.Status) {
            this.fetchData();
            this.edittestimonaildialog = false;
            this.btnloader=false;
            setTimeout(() => {
              this.$swal.fire({
                position: "top-end",
                icon: "success",
                title: res.Message,
                showConfirmButton: false,
                timer: 3000,
                toast: true,
              });
            }, 500);
          } else {
            this.btnloader=false;
            setTimeout(() => {
              this.$swal.fire({
                position: "top-end",
                icon: "error",
                title: res.Message,
                showConfirmButton: false,
                timer: 3000,
                toast: true,
              });
            }, 1500);
          }
        });
    },
    openDelDialouge(id) {
      this.dialog = true;
      this.selectedTestimonial = id;
    },
    previewDialouge(item) {
      this.infodialog = true;
      this.selectedTestimonial = item;
    },
    editDialouge(item) {
      this.edittestimonaildialog = true;
      this.selectedTestimonial = item;
    },
    cleanFilter() {
      this.filterObj = {};
    },
    DdialogClose() {
      this.btnloader = true;
      setTimeout(() => {
        this.deleteTestimonial();
        this.dialog = false;
        this.btnloader = false;
        this.$swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "Deleted Successfully",
          showConfirmButton: false,
          timer: 1500,
        });
      }, 1000);
      
      
      // this.ErrorToast = true;
      // setTimeout(() => {
      //   this.ErrorToast = false;
      // }, 1500);
    },

    closeDialog() {
      this.value = false;
    },
    close() {
      this.SuccessToast = false;
      this.ErrorToast = false;
    },
  },
};
</script>
<style scoped>
.index_test_h1 {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;

  color: #222222;
}

.index_test_h2 {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;

  color: #222222;
}
.box {
  white-space: nowrap;
  max-width: 20vw;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  box-shadow: none;
  background-color: transparent;
}
.v-text-field--outlined >>> fieldset {
  border-color: #e0e0e0;
}
</style>
